import { StageNumberBadge } from './StageNumberBadge';
import type { StageStepperStyles } from './stageStepperStyles';

export const StageStepperSummary = ({
  activeIndex,
  stageCount,
  primaryLabel,
  styles,
}: {
  activeIndex: number;
  stageCount: number;
  primaryLabel: string;
  styles: StageStepperStyles;
}) => (
  <div data-stage-stepper-summary='true' css={styles.minimalSummary}>
    <StageNumberBadge state='active' index={activeIndex} styles={styles} />
    <div css={styles.activeSummaryCopy}>
      <div css={styles.labelByState.active}>{primaryLabel}</div>
      <div data-stage-stepper-position='true' css={styles.positionLabel}>
        {activeIndex + 1} of {stageCount}
      </div>
    </div>
  </div>
);
